import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { ClipLoader } from "react-spinners";
import { Button } from "zina-dogi-react";
import { Formik, Form, Field } from "formik";
import { Row, Col } from "reactstrap";
import swal from "sweetalert";
import { utils } from "../../../utils";


class SelectItemModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            comments: [],
            requestData: {},
            withOnSend: false,
            nextStep: null,
            items: {
                item_0: null,
            },
            item_count: 0,
            isLoadig: false,
        };

    }

    close = () => {
        this.setState({
            modal: false,
            items: {
                item_0: null,
            },
            item_count: 0,
            isLoadig: false,
        });
    };

    open = () => {
        this.setState({
            modal: true,
            item_count: 0,
        });
    };

    toggle = () => {
        const modal = !this.state.modal;
        if (modal) {
            this.open();
        } else {
            this.close();
        }
    };

    addItem = () => {
        const items = { ...this.state.items }
        let item_count = this.state.item_count
        item_count++
        const key = 'item_'.concat(item_count.toString())
        items[key] = ""
        this.setState({ items, item_count });
    }

    onSubmit = (values, formik) => {
        const { runID, path } = this.props
        if (Object.values(values).every((value)=> value === null)) {
            swal({
                title: "Error",
                text: "All items are empty. Please choose full process or select an item",
                icon: "error",
                button: true
            })
            return
        }
        this.setState({ isLoadig: true });
        this.props
            .onSubmit(runID, values, path)
            .then((results) => {
                this.setState({ isLoadig: false });
                formik.setSubmitting(false);
                this.toggle();
                swal({
                    title: results.detail ? "Success" : "Error",
                    text: results.detail ? results.detail : utils.computeError(results),
                    icon: results.detail ? "success" : "error",
                    button: true
                });
                
            })
            .catch(error => {
                this.setState({ isLoadig: false });
                swal({
                    title: "Error!",
                    text: utils.computeError(error),
                    icon: "error",
                    button: true
                });
            });
    }

    render() {
        const { className, buttonLabel, title } = this.props;
        const { modal } = this.state;
        const modalStyle = { width: "30%", maxWidth: "30%" };
        const initialValues = {
            ...this.state.items
        }
        return (
            <div>
                {buttonLabel && (
                    <Button color="primary" onClick={this.toggle}>
                        {buttonLabel}
                    </Button>
                )}
                <Modal isOpen={modal} toggle={this.toggle} className={className} backdrop="static" style={modalStyle}>
                    <ModalHeader toggle={this.toggle}>{title}</ModalHeader>
                    <ModalBody>
                        <Formik onSubmit={this.onSubmit} initialValues={initialValues}>
                            {({ values: v, ...formik }) => {
                                return (
                                    <Form className="form" id='form'>
                                        <div className="fields">
                                            <Row>
                                                {Object.keys(this.state.items).map((item, idx) => {
                                                    return (
                                                        <Col md={3} key={item}>
                                                            <div className="form-group">
                                                                <label>{'Item #'.concat(idx.toString())}</label>
                                                                <Field
                                                                    name={item}
                                                                    type="number"
                                                                    style={{ width: "75px" }}

                                                                />
                                                            </div>
                                                        </Col>
                                                    );
                                                })
                                                }

                                            </Row>
                                            {/* {path != 'request-grn-job' && (
                                                <Button
                                                type="button"
                                                color="success"
                                                style={{ width: "75" }}
                                                onClick={this.addItem}
                                                className="mr-1"
                                            >
                                                Add
                                                </Button>
                                            )} */}
                                        </div>
                                    </Form>
                                );
                            }}
                        </Formik>
                    </ModalBody>
                    <ModalFooter>
                        <Row>
                            {this.state.isLoadig && (
                                <ClipLoader />
                            )}
                            <Button
                                type="submit"
                                color="primary"
                                style={{ width: "150px" }}
                                className="mr-1"
                                form='form'
                            >
                                Send job
                            </Button>
                            <Button
                                className="btn-danger mr-1"
                                onClick={this.toggle}
                                type="button"
                                name="Close"
                                style={{ width: "150px" }}
                            >
                                Cancel
                            </Button>
                            
                            
                        </Row>

                    </ModalFooter>
                </Modal>
            </div>
        );
    }
    _cancel = () => {
        this.close();
    };
}

export default SelectItemModal;